import e from "@dialpad/dialtone-tokens/layered/themes/tokens-high-desert-colors.css?inline";
//#region themes/high-desert.js
var t = { brand: {
	css: e,
	name: "high-desert"
} };
//#endregion
export { t as default };
